import cartImport from './CartImport/texts.js';

export default {
  cartImport,
  content: {
    title: {
      notes: 'Title in the cart view',
      message: 'Cart',
    },
    empty: {
      text: {
        notes: 'Text of empty state when cart is empty',
        message:
          'Not parts in cart. You can add articles in "{{partsMenuName}}", among other places.',
      },
    },
    emptyDeliveryPoint: {
      text: {
        notes:
          'Text of empty state when cart is empty for selected deliverypoint',
        message:
          'No articles in the cart for the currently selected delivery address. You can add articles in "{{partsMenuName}}", among other places.',
      },
    },
  },
  action: {
    import: {
      notes: 'Cart import action',
      message: 'Import',
    },
    export: {
      notes: 'Cart export action',
      message: 'Export',
    },
    print: {
      notes: 'Cart print action',
      message: 'Print',
    },
    share: {
      notes: 'Cart share action',
      message: 'Share',
    },
    savePdf: {
      notes: 'Cart save pdf',
      message: 'Save pdf',
    },
    saveAsTemplate: {
      notes: 'Cart save as template',
      message: 'Save as template',
    },
    addToTemplate: {
      notes: 'Action to add items to cart template',
      message: 'Add to template',
    },
    removeItem: {
      notes: 'Action to remove item from cart',
      message: 'Remove',
    },
    openCart: {
      notes: 'Action to open cart',
      message: 'Open cart',
    },
    addToCart: {
      notes: 'Action to add item to the cart',
      message: 'Add to cart',
    },
    deliverTo: {
      notes: 'Action to deliver selected items to a delivery address',
      message: 'Deliver to',
    },
    deliverAllTo: {
      notes: 'Action to deliver all items to a delivery address',
      message: 'Deliver all to',
    },
    delete: {
      notes: 'Cart delete action',
      message: 'Delete',
    },
    duplicate: {
      notes: 'Cart duplicate action',
      message: 'Duplicate',
    },
    rename: {
      notes: 'Cart rename action',
      message: 'Rename',
    },
    findRelated: {
      notes: 'Cart find related action',
      message: 'Find related',
    },
    moveItemBackToCard: {
      notes: 'Move item back to cart action',
      message: 'Put back to cart',
    },
  },
  item: {
    model: {
      emptyCartAllocator: {
        notes: 'Title of group without allocator',
        message: 'Other',
      },
      position: {
        notes: 'Name of field "position" for items in cart',
        message: 'Pos',
      },
      quantity: {
        notes: 'Name of field "quantity" for items in cart',
        message: 'Qty',
        stockExceeded: {
          notes:
            'Help text that user is about to buy a larger amount than is available in the closest stock',
          message:
            'Selected quantity is greater than availability ({{availableQuantity}} available {{closestStock}}). Choose "partial" as a delivery option in the checkout to ship the available parts now, and the remaining once they become available.',
        },
      },
      deliveryPoint: {
        notes: 'Name of field "delivery point" for items in cart',
        message: 'Delivery address',
        placeholder: {
          notes: 'Placeholder text for selecting delivery point',
          message: 'Deliver to...',
        },
      },
      taggedToEq: {
        notes: 'Name of field "tagged to equipment" for items in cart',
        message: 'Tagged to',
        placeholder: {
          notes: 'Placeholder text for selecting equipment',
          message: 'For equipment...',
        },
      },
    },
  },
  missingDeliveryPointSection: {
    header: {
      notes: 'Header of section for items without a delivery address specified',
      message: 'Delivery address missing',
    },
    helpText: {
      notes:
        'Help text in section for items without delivery address specified',
      message:
        'Checkout for these articles will be possible once their pricing has been determined based on their delivery address.',
    },
  },
  deliveryPointSection: {
    header: {
      notes: 'Accordion header for cart content',
      message: 'Articles',
    },
    helpText: {
      notes:
        'Help text in delivery address section explaining that some item lines have',
      message:
        'Some order lines have higher selected quantity than the availability and shipment of these items may take longer. Choose "partial" as a delivery option in the checkout to ship the available parts now, and the remaining once they become available.',
    },
  },
  subtotalCard: {
    deliveryAddress: {
      notes: 'Label for the delivery address',
      message: 'Delivery address:',
    },
    subtotal: {
      notes: 'Label describing total price of items about to be checked out',
      message: 'Subtotal',
    },
    totalWeight: {
      notes:
        'Label describing the total weight of product about to be checked out',
      message: 'Total weight',
    },
    lineCount: {
      notes:
        'Label describing the number of lines (products) about to be checked out',
      message: 'Number of lines',
    },
    deliveryDate: {
      notes: 'Label for Estimated delivery date',
      message: 'Estimated delivery date',
    },
    approximateTotalWeight: {
      notes:
        'Information when total weight can not be exactly calculated due to missing weight on articles',
      message:
        'Total weight is approximate. Some of the articles have no weight specified.',
    },
    priceMissing: {
      notes: 'Information when item(s) is missing a price preventing checkout',
      message:
        'Some of the articles are missing price information. To proceed with the order contact your customer support representative to update pricing.',
    },
  },
  notification: {
    itemAddedToCartSuccess: {
      notes: 'Message that item was successfully added to cart',
      message: '{{quantity}} {{name}} added to cart',
    },
    itemAddedToCartNoDetailsSuccess: {
      notes: 'Message that item was successfully added to cart without details',
      message: 'Article added to cart',
    },
    itemsAddedToCartSuccess: {
      notes: 'Message that multiple items was successfully added to cart',
      message: '{{itemCount}} articles added to cart',
    },
    itemUpdateDeliveryAddressSuccess: {
      notes:
        'Message that new delivery address was successfully updated on item',
      message: '{{name}} delivery address updated to "{{newDeliveryAddress}}"',
    },
    itemClearDeliveryAddressSuccess: {
      notes:
        'Message that new delivery address was successfully cleared on item',
      message: '{{name}} delivery address removed',
    },
    saveCartError: {
      notes: 'Message when failing to save cart',
      message:
        'Ops! Failed to save the cart. Reload the page if the problem occurs again.',
    },
    itemSuperseded: {
      notes: 'Message when item has been superseded',
      message:
        'Article no {{fromArticleNo}} has been replaced by {{toArticleNo}}. Articles in the cart have been replaced.',
    },
  },
  deliverToDialog: {
    header: {
      notes: 'Header text for dialog Deliver to',
      message: 'Deliver to',
    },
    instruction: {
      notes: 'Instruction text for dialog Deliver to',
      message: 'Select delivery address for the below articles.',
    },
  },
  noWritePermit: {
    notes:
      'Tooltip displayed on Add to cart button when permit to add is missing',
    message:
      'You do not have permission to add to cart for the selected deliverypoint',
  },
  outPhased: {
    notes:
      'Information displayed for article items that has been phased out (inactive items)',
    message: 'The article has been phased out',
  },
  footer: {
    subtotalButton: {
      notes: 'Label on button for subtotal in cart footer',
      message: 'Subtotal: ',
    },
  },
};
